import MovieCard from "@/components/base/MovieCard";
import type { Movie } from "@/mocks/movies";

export default function RelatedMovies({ items, type }: { items: Movie[]; type: string }) {
  if (items.length === 0) return null;

  return (
    <section>
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-900">相关推荐</h2>
          <p className="mt-1 text-xs text-foreground-500">根据类型与题材标签匹配，可能符合你的口味。</p>
        </div>
        <span className="text-xs text-foreground-400">{type} · 同类型推荐</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {items.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}